<template>
<div class="container bookList">
<div class="text-center  m4u_text--text"></div>
  <p class="pageHeading m4u_text--text">Invite a charter member to join Memories For Us</p>

   <v-form v-model="valid" ref="form" lazy-validation>
    <v-container>
      <v-card>
        <v-card-text>
      <h3 class="m4u_text--text">Who do you want to invite?</h3>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="invitee"
            :rules="nameRules"
            :counter="50"
            label="Name of the person to invite"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
        <v-select
          v-model="selectedCharter"
          :items="charterItems"
          item-text="charterName"
          item-value="charterValue"
          label="Charter Type">
        </v-select>
        </v-col>
      </v-row>
      {{message}}
      </v-card-text>
      <v-btn class="primary mb-2 ml-3 m4u_text--text button" @click="sendAdminInvitation()">Invite</v-btn>
      </v-card>
    </v-container>
  </v-form>
</div>
</div>
</template>
<script>

import EventService from '@/services/EventService.js'; 

export default {
 name: "Invitation",
  data() {
    return {
        selectedCharter: '',
        charterItems:  [
          { charterName: '10 free friend memberships', charterValue: 2 },
          { charterName: '5 free friend memberships', charterValue: 3 },
          { charterName: '0 free friend memberships', charterValue: 4 },
        ],
        tcMonth: '',
        tcDay: '',
        tcYear: '',
        tcDate: '',
        valid: false,
      invitee: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 50 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      message: '',
      freeInvitations: ''
       }
    },
  
  components: {

  },
  
mounted() {
  this.setUpDate();

  },


computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },

},

  methods: {
      async sendAdminInvitation() {
        this.message = '';
      await EventService.sendAdminInvitation(this.user.UserID, this.invitee, this.email, this.tcDate, this.user.UserDisplayName, this.selectedCharter)
      .then(
        (invitationreturn => {
          if(invitationreturn === 'Duplicate'){
            this.message = 'You have already invited this person.'
          } else if (invitationreturn === 'Member') {
            this.message = 'This person is already a member.'
          }
          else {
            this.message = 'Your invitation to ' + this.invitee + ' has been sent.';
            this.invitee = '';
            this.email = '';
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
          }
        })
      )

    },


    async setUpDate() {
      var dateObj = new Date();
      this.tcMonth = dateObj.getUTCMonth() + 1; //months from 1-12
      if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
 //     console.log('this.tcMonth is: ', this.tcMonth)
      this.tcDay = dateObj.getUTCDate();
       if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcYear = dateObj.getUTCFullYear();
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
    }
  }

}


</script>
<style lang="scss" scoped>
  .button {
    font-weight: 600;
  }

  .formCard {
    max-width: 90%;
    justify-content: center;
  }

  .pageHeading {
    font-size: 1.25em;
    font-weight: 600;
  }

  .pageSubHeading {
    font-size: 1em;
  }

  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }


</style>